module.exports = __webpack_public_path__ + "img/location-crosshairs-slash.d7e5ea24.svg";